import React, { Component } from 'react'
import CreateTicketForm from './createTicketForm'
import { ModalWrapper } from './modalWrapper'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  submitCreateTicket: Callback
  currentConv: object
}

export class CreateTicketModal extends Component<Props> {
  static displayName = 'CreateTicketModal'

  handleSubmit = (values) => {
    const { submitCreateTicket, currentConv } = this.props
    return submitCreateTicket(currentConv, values)
  }

  render() {
    return (
      <ModalWrapper title="Create Zendesk ticket" {...this.props}>
        <CreateTicketForm onSubmit={this.handleSubmit} {...this.props} />
      </ModalWrapper>
    )
  }
}
